import { isValidPhoneNumber } from "libphonenumber-js";

export const validatePhoneNumber = (
    phone: string,
    input: HTMLInputElement | null
) => {

    if (!input) return false;

    if (!phone) {
        input.setCustomValidity(
            "Phone number is required"
        );

        input.reportValidity();

        return `+${phone}`;
    }

    const formattedPhone = phone.startsWith("+")
        ? phone
        : `+${phone}`;

    const isValid =
        isValidPhoneNumber(formattedPhone);

    input.setCustomValidity(
        isValid
            ? ""
            : "Please enter a valid phone number"
    );

    input.reportValidity();

    return `+${phone}`;
};
